<bzg-modal-header>
    <span class="bz-modal__title">{{'GLOBAL.SAVE_CHANGES_TITLE' | translate}}</span>
    <bzg-button-icon icon="icn-close" (click)="dispathModalAction('close')"></bzg-button-icon>
  </bzg-modal-header>
  <bzg-modal-content class="mcw-save-dialog_body">
    <p class="mcw-save-dialog_text">
      {{ 'GLOBAL.SAVE_CHANGES_MESSAGE' | translate}}
    </p>
  </bzg-modal-content>
  <bzg-modal-footer class="mcw-save-dialog_footer">
      <bzg-button-secondary (click)="dispathModalAction('cancel')" class=" bz-space--inline-m">{{ 'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
      <bzg-button-secondary (click)="dispathModalAction('dontsave')" class=" bz-space--inline-m">{{ 'GLOBAL.DONT_SAVE' | translate}}</bzg-button-secondary>
      <bzg-button-primary (click)="dispathModalAction('save')" class=" bz-space--inline-m">{{ 'GLOBAL.SAVE' | translate}}</bzg-button-primary>
  </bzg-modal-footer>
  